import { AboutTeam, Banner, Instituciones, Mision, Vision } from "../components";

const Home = () => {
  return (
    <main>
      <Banner />
      <AboutTeam />
      {/* VISION */}
      <Vision />
      {/* MISION */}
      <Mision />
      {/* SEGEPLAN */}
      <Instituciones />
    </main>
  );
}

export default Home;